// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewRvsp_wrapper__qQu+K","intro":"ViewRvsp_intro__tiVWC","totalCount":"ViewRvsp_totalCount__Sg+ll","table":"ViewRvsp_table__PBUGf"};